import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const EMPTY_FAVORITES: string[] = [];

interface FavoritesStore {
  byUser: Record<string, string[]>;
  getFavorites: (userId: string) => string[];
  toggleFavorite: (userId: string, itemName: string) => void;
  setFavorites: (userId: string, items: string[]) => void;
  isFavorite: (userId: string, itemName: string) => boolean;
}

export const useFavoritesStore = create<FavoritesStore>()(
  persist(
    (set, get) => ({
      byUser: {},
      getFavorites: (userId) => get().byUser[userId] || [],
      toggleFavorite: (userId, itemName) => {
        const current = get().byUser[userId] || [];
        const next = current.includes(itemName)
          ? current.filter((id) => id !== itemName)
          : [...current, itemName];
        set({ byUser: { ...get().byUser, [userId]: next } });
      },
      setFavorites: (userId, items) => {
        set({ byUser: { ...get().byUser, [userId]: items } });
      },
      isFavorite: (userId, itemName) => (get().byUser[userId] || []).includes(itemName),
    }),
    { name: 'pos-favorites', storage: createJSONStorage(() => localStorage) },
  ),
);

/** Subscribe to the user's favorite IDs so the UI re-renders when they change. */
export function useFavoriteIds(userId: string) {
  return useFavoritesStore((s) => (userId ? s.byUser[userId] : undefined) ?? EMPTY_FAVORITES);
}
